module.exports = __webpack_public_path__ + "assets/img/all_award_item.147c6990.png";